import CryptoJS from 'crypto-js'
export function encrypt(word) {
  var key = CryptoJS.enc.Utf8.parse('f4k9f5w7f8g4er26')
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var iv = CryptoJS.enc.Utf8.parse('5e8y6w45ju8w9jq8')
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv: iv })
  return encrypted.toString()
}
